import React from "react";

const EcartsBudget = () => {
  return (
    <div className="ecarts-budget">
      <h2>Écarts budgétaires</h2>
      <p>Analyse des écarts entre prévisions et réalisations.</p>
    </div>
  );
};

export default EcartsBudget;
